import classNames from 'classnames';
import { ReactNode } from 'react';

import style from './wrapper.module.css';

interface WrapperProps {
  children: ReactNode;
  className?: string;
}

const Wrapper = ({ children, className }: WrapperProps) => {
  return (
    <div className={classNames(style.wrapper, className)}>
      {children}
    </div>
  );
};

export default Wrapper;
